export const isProduction = process.env.NODE_ENV === 'production';
export const isDev = process.env.NODE_ENV === 'development';
export const isDemo = process.env.REACT_APP_ENV === 'demo';
